<template>
  <v-flex xs12>
    <v-card>
      <v-card-text>
        <h4>Licenses:</h4>
        <p>
          Total Licenses: {{totalLicenses}}
          <br>
          Invites Sent: {{sentLicenses}}
          <br>
          Invites Remaining: {{totalLicenses - sentLicenses}}
          <br>
          <br>
        </p>

        <v-layout row justify-center>
          <v-dialog v-model="dialog" scrollable persistent max-width="600px">
            <v-btn slot="activator" small outline>Add Licenses</v-btn>

            <v-card v-if="confirm">
              <v-card-title>
                <span
                  class="headline"
                >Confirm Adding {{newlicensesList.length}} Licenses for {{obj.name}}</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text style="height: 300px;">
                <v-chip v-for="(item, index) in newlicensesList" :key="index">{{item}}</v-chip>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="confirm = false">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>

            <v-card v-else>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-title>
                  <span class="headline">Add Licenses for {{obj.name}}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-textarea
                          v-model="newlicenses"
                          label="License Keys"
                          :rules="licenseRules"
                          required
                          hint="Paste a list of keys here, seperated by commas, spaces or new lines."
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
                  <v-btn color="blue darken-1" flat @click="submit">Submit</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>

          <v-btn v-if="availableLicenses" small outline :to="{name:'Invite Users', params: {noid:id}}">Invite Users</v-btn>

        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
/*global firebase*/
export default {
  name: "NatOrgLicenses",
  props: {
    id: String,
    obj: Object
  },
  data: () => ({
    dialog: false,
    valid: true,
    confirm: false,
    newlicenses: null,
    newlicensesList: null,
    licenseRules: [v => !!v || "License keys are required"]
  }),
  computed: {
    totalLicenses() {
      let noLicenses = this.$store.state.noLicenses[this.id]
      if (noLicenses) {
        noLicenses = Object.values(noLicenses)
        return noLicenses.length;
      }
      return 0;
    },
    sentLicenses() {
      let noLicenses = this.$store.getters.licensesByNo(this.id)
      if (noLicenses) {
        noLicenses = Object.values(noLicenses)
        return noLicenses.filter(lic => lic.sent).length;
      }
      return 0;
    },
    availableLicenses() {
      return this.totalLicenses - this.sentLicenses
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.newlicensesList = this.newlicenses
          .replace(/\n/g, ",")
          .split(/[ ,]+/)
          .filter(function(v) {
            return v !== "";
          });
        this.confirm = true;
      }
    },
    save() {
      let updates = {};
      this.newlicensesList.map(license => {
        let newLicenseKey = firebase
          .database()
          .ref()
          .child("licenseinvites/" + this.id)
          .push().key;
        updates["licenseinvites/" + this.id + "/" + newLicenseKey] = {
          license: license,
          accepted: false,
          sent: false
        };
      });
      firebase
        .database()
        .ref()
        .update(updates);

      // reset
      this.confirm = false;
      this.newlicenses = null;
      this.newlicensesList = null;

      // close dialog
      this.dialog = false;
    }
  }
};
</script>
